import { Injectable } from '@angular/core';
import { Observable,  } from 'rxjs';
import { MessageService } from '../message.service';
import { HttpClient, HttpHeaders }from '@angular/common/http';
import { Account, PagedResponseAccount } from '../models/Account';
import { environment } from 'src/environments/environment';
import { KaizenAccount } from '../models/kaizen-account';
 


@Injectable({
  providedIn: 'root'
})



export class AccountService {
  readonly APIURL = environment.APIURL;
  constructor(private messageService:MessageService, private http:HttpClient) { }

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  getAccounts(email: string):Observable<PagedResponseAccount>{
    const data =  this.http.get<PagedResponseAccount>(this.APIURL+'/GLAccountImpactArea' + '?PageNumber=1&PageSize=50'+ '&Email=' + email);
    this.messageService.add('Account Service: fetched GLAccountImpactArea');
    
    return data;
  }

  getAccount(id: number): Observable<Account> {
        const Account =this.http.get<Account>(this.APIURL+'/GLAccountImpactArea/' + id);
    this.messageService.add(`Account Service: fetched Account with id=${id}`);
    return Account;
  }


 


}